var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MAIN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(-355.000000, -104.000000)",
    stroke: "#343334",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(356.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -1.8189894e-12,
    x2: 18.408952,
    y2: 18.408952,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -1.8189894e-12,
    x2: 18.408952,
    y2: 18.408952,
    id: "Path-7",
    transform: "translate(9.204476, 9.204476) rotate(90.000000) translate(-9.204476, -9.204476) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelDark);
export default __webpack_public_path__ + "static/media/cancel-dark.f4fd8ce90e4664e08ea41763e83bb52d.svg";
export { ForwardRef as ReactComponent };